var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfSoloCall.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" Solo")],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da223f5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/Solo.vue
// module id = jEor
// module chunks = 0